import { Navigate, Outlet, useLocation } from 'react-router';
import { AppProvider } from '@/context/AppContext';
import * as storage from '@/_helper/storage';
import { checkAndPerformRedirect } from '@/_helper/checkAccess';
import { AutoLogout } from '@/comp/autoLogout';

export const ProtectedRoute = ({ children }: { children?: React.ReactNode }) => {
    const location = useLocation();

    // If user is not logged in, redirect to login page
    if (!storage.get('access_token') || !storage.get('login')) {
        return <Navigate to="/login" replace state={{ from: location }} />;
    }

    // Check for redirects when user is logged in and location changes
    if (storage.get('access_token') !== null) {
        const redirectTarget = checkAndPerformRedirect(location.pathname);

        if (redirectTarget && redirectTarget !== location.pathname) {
            return <Navigate to={redirectTarget} replace />;
        }
    }

    if (location.pathname !== 'login' && location.pathname !== 'logout') {
        document.querySelector('html')?.classList.remove('redesign');
    }

    if (window.$affiliate === 'ch24') {
        return (
            <AppProvider isAffiliate>
                {children ? children : <Outlet key={`protected-${location.pathname.split('/')[1]}`} />}
            </AppProvider>
        );
    }

    return (
        <AppProvider>
            <AutoLogout>
                {children ? children : <Outlet key={`protected-${location.pathname.split('/')[1]}`} />}
            </AutoLogout>
        </AppProvider>
    );
};
export default ProtectedRoute;
